var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { css } from '@emotion/react';
import { darkThemeStyle, theme } from '../theme';
import { tokens } from '../tokens';
var tooltipStaticStyle = css({
    borderRadius: tokens.borderRadius.medium,
    maxWidth: '300px',
    padding: "".concat(tokens.spacing.small, " 12px"),
    position: 'absolute',
    zIndex: 10,
});
export function tooltipStyle(_a) {
    var inverted = _a.inverted, x = _a.x, y = _a.y;
    return __spreadArray(__spreadArray([], __read((inverted ? [darkThemeStyle] : [])), false), [
        tooltipStaticStyle,
        css({
            backgroundColor: theme.background.contrastInverse,
            color: theme.text.inverse,
            left: x !== null && x !== void 0 ? x : 0,
            top: y !== null && y !== void 0 ? y : 0,
        }),
    ], false);
}
